import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import { TGetWorkerAstraUserResponseSchema } from "../getWorkerAstraUser/getWorkerAstraUser.schema";

export const updateWorkerAstraUser = (axios: IAxiosInstance) => {
  return async (params: {
    readonly worker_id: string;
    readonly is_acknowledged: boolean;
  }) => {
    const { worker_id, is_acknowledged } = params;
    const { data } = await axios.noRetry.patch<
      IApiResponse<TGetWorkerAstraUserResponseSchema>
    >(`/push-to-card/worker`, {
      workerID: worker_id,
      isAcknowledged: is_acknowledged,
    });

    return data.data;
  };
};
